import { Button } from 'components/button';
import React from 'react';
import { useIntl } from 'react-intl';

import styles from './empty-state.module.scss';

export interface IEmptyStateProps {
	onClearFilters?: () => void;
	isLoading?: boolean;
}

const EmptyState = (props: IEmptyStateProps): React.JSX.Element => {
	const intl = useIntl();
	const title = props.onClearFilters
		? intl.formatMessage({ id: 'components.emptyState.noFilterResults' })
		: intl.formatMessage({ id: 'components.emptyState.noResults' });

	return (
		<div className={styles.EmptyState}>
			<div className={styles.content}>
				<div>{title}</div>

				{props.onClearFilters && (
					<Button
						variant="secondary"
						onClick={props.onClearFilters}
						title={intl.formatMessage({ id: 'components.emptyState.resetFilters' })}
						disabled={props.isLoading}
					/>
				)}
			</div>
		</div>
	);
};

export { EmptyState };
